<template>
    <fragment>
        <div class="details" v-for="(traitItems, type) in grouppedTraits" :key="`trait-items-${type}`">
            <span v-text="type"></span>
            <span v-for="trait in traitItems"
                  :key="trait.id"
                  class="trait-class"
                  v-html="printTraits(type, trait, traitItems)">
                </span>
        </div>
    </fragment>
</template>
<script>

import { Fragment } from 'vue-fragment'

export default {

    components: {
        Fragment,
    },

    props: ['traits'],

    methods: {
        printTraits(type, trait, traits) {
            let index = _.findIndex(traits, t => t.id == trait.id)
            if (index == 0 && traits.length == 1 || index == (traits.length - 1))
                return trait.name
            if (index == 0 && traits.length == 2 || index == (traits.length - 2))
                return trait.name + "&nbsp;&nbsp;&amp;&nbsp;&nbsp;"
            if (index >= 0 && traits.length > 2)
                return trait.name + ",&nbsp;&nbsp;"
        }
    },

    computed: {
        grouppedTraits() {
            return _.groupBy(this.traits, trait => {
                return trait.pivot.value;
            })
        }
    }
}
</script>
<style lang="scss">
.activity-item-rating {
    .details {
        .trait-class {
            font-family: 'Bureau Grot Bk', helvetica;
            font-weight: 400;
            font-size: 12px;
            display: inline-block;
            font-style: normal;
        }
    }
}
</style>
